const sliderSelector = '.nd-slider';
const initializedAttribute = 'data-nd-slider-initialized';
const mobileBreakpoint = 768;

const responsiveOptions = {
  perPage: 2,
  perMove: 1,
  breakpoints: {
    [mobileBreakpoint]: {
      perPage: 1,
      perMove: 1,
    },
  },
};

function applySplideClasses(slider) {
  slider.classList.add('splide');

  slider.querySelector('.nd-slider__track')?.classList.add('splide__track');
  slider.querySelector('.nd-slider__list')?.classList.add('splide__list');

  slider.querySelectorAll('.nd-slider__slide, .nd-slider__item').forEach((slide) => {
    slide.classList.add('splide__slide');
  });
}

function hasSplideMarkup(slider) {
  return Boolean(
    slider.querySelector('.splide__track')
    && slider.querySelector('.splide__list')
    && slider.querySelector('.splide__slide')
  );
}

export function initSlider() {
  if (!window.Splide) {
    return;
  }

  document.querySelectorAll(sliderSelector).forEach((slider) => {
    if (slider.hasAttribute(initializedAttribute)) {
      return;
    }

    applySplideClasses(slider);

    if (!hasSplideMarkup(slider)) {
      return;
    }

    const splide = new window.Splide(slider, responsiveOptions);
    splide.mount();

    slider.setAttribute(initializedAttribute, 'true');
  });
}
